<ui-switch
  [ngClass]="{ off: !_value }"
  [checked]="_value"
  (valueChange)="onModelChange($event)"
  color="var(--cds-bg-ml)"
  defaultBgColor="var(--cds-bg-inactive)"
  checkedLabel=""
  uncheckedLabel=""
  [beforeChange]="beforeChange"></ui-switch>
